import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown, faPhone, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faLinkedin, faTwitterSquare } from '@fortawesome/free-brands-svg-icons';

library.add(faCaretDown, faPhone, faAngleDown, faFacebookSquare, faLinkedin, faTwitterSquare);

document.addEventListener('DOMContentLoaded', () => dom.i2svg());
